import { useEffect, useState } from "react";
import Form from "../../../components/Form/Form";
import UploadButton from "../../../components/UploadButton/UploadButton";
import { useUserStore } from "../../../contexts/userStore";
import ImagesService from "../../../services/ImagesService";
import UserService from "../../../services/UserService";
import { useAuth } from "../../../contexts/auth";
import { useNavigate } from "react-router-dom";
import { Buffer } from "buffer";
import Loader from "../../../components/Loader/Loader";

export function ChangePhoto() {
	const [showLoader, setShowLoader] = useState(false);
	const { getUrlPreference } = useUserStore();
	const [photoFile, setPhotoFile] = useState();
	const [currentPhotoFile, setCurrentPhotoFile] = useState();
	const { user, storeUser } = useAuth();
	const [urlAvatar, setUrlAvatar] = useState();
	const navigate = useNavigate();

	async function loadCurrentPhotoFile(urlAvatar) {
		if (!urlAvatar) return;
		const response = await ImagesService.getImage(urlAvatar);
		if (!response.data) return;
		const responseImage = await ImagesService.getRawImage(response.data.replace("[:STORAGE_ADDRESS:]", window.location.hostname));
		const binaryData = responseImage.data;
		const base64Data = new Buffer.from(binaryData, "binary").toString(
			"base64",
		);
		const originalDataUrl = `data:image/png;base64,${base64Data}`;
		setCurrentPhotoFile(originalDataUrl);
	}

	useEffect(() => {
		if (!user.userData.urlAvatar) return;
		setUrlAvatar(user.userData.urlAvatar);
		loadCurrentPhotoFile(user.userData.urlAvatar);
	}, [user.userData]);

	async function salvarFoto(event) {
		event.preventDefault();
		setShowLoader(true);
		const formData = new FormData();
		formData.append("file", photoFile);
		formData.append("entity", "cloudUser");
		const responseImage = await ImagesService.storeImage(formData);
		let img = { urlAvatar: responseImage.data.payload.id };
		const response = await UserService.updateUser(user.userData.userId, img);
		setShowLoader(false);
		if (!response.data.id) return;
		storeUser({
			userData: {
				...user.userData,
				urlAvatar: responseImage.data.payload.id
			}
		});
		navigate(getUrlPreference());
	}

	return (
		<>
			{showLoader ? (
				<Loader />
			) : (
				<Form
					handleSubmit={salvarFoto}
					navigateCancelUrl={getUrlPreference()}
				>
					<div className="edit-profile-avatar-container">
						<p className="edit-profile-title-details">
							Modificar Foto de Perfil
						</p>
						<div className="edit-profile-import-avatar-btn">
							<UploadButton
								onFileChanged={(file) => setPhotoFile(file)}
								label="Importar Foto"
								placeholderText="Arraste ou clique para adicionar Foto"
								currentFileBase64={currentPhotoFile}
							/>
						</div>
					</div>
				</Form>
			)}
		</>
	);
}